import { Component, Input, OnInit } from '@angular/core';

declare var $ : any;
interface IWindow extends Window {
	webkitSpeechRecognition : any;
	SpeechRecognition : any;
}
declare let alertify : any;
declare let localforage : any;
declare let window : any;

@Component({
	selector: 'app-book-detail-item',
	templateUrl: './book-detail-item.component.html',
	styleUrls: ['./book-detail-item.component.css']
})
export class BookDetailItemComponent implements OnInit {

	@Input('') bookDetail : any = null;
	constructor() { }

	dictionaryWords : any[] = [];

	ngOnInit() : void {
		const s = this.formartBeforeSpeaking(this.bookDetail?.id);
		setTimeout(function (s_ : string) {
			if ("speechSynthesis" in window) {
				var msg = new SpeechSynthesisUtterance();
				msg.text = s;
				window.speechSynthesis.speak(msg);
			}
		}, 100, s);

		setTimeout(function () {
			$('[data-toggle="popover"]').popover({
				trigger: 'click',
				placement: 'bottom'
			});
			$('[data-toggle="popover"]').on('show.bs.popover', function (e : any) {
				if (e && e.target) {
					setTimeout(function (el : any) {
						const s = el.innerText;
						var id = el.getAttribute('aria-describedby') || '';
						//console.log(s, id);
						if (id.length > 0) {
							const pop = document.querySelector('#' + id + ' .popover-body');
							if (pop) {
								pop.innerHTML = '<a target="_blank" href="https://dictionary.cambridge.org/dictionary/english/' + s + '">Dictionary Cambridge for [ ' + s + ' ]</a>'
									+ '<br><a target="_blank" href="https://www.oxfordlearnersdictionaries.com/definition/english/' + s + '_1?q=' + s + '">Dictionary Oxford for [ ' + s + ' ]</a>';
							}
						}
					}, 500, e.target);
				}
			})
		}, 1000);
	}

	formartBeforeSpeaking(s : string) {
		let t = (s || '').toLowerCase().split(' or ').join(' ').split(' and ').join(' ').split(' + ').join(' ');
		return t;
	}

	getCdnImage(url : string) {
		let s = url || '';
		let fix = 'http://static.bilet.vn/static/';
		if (s.length > fix.length)
			s = window['__cdn_static'] + s.substr(fix.length);
		console.log(s);
		return s;
	}

	setupMenuDictionaryItems(text : string) {
		return (text || '').split(' ');
	}

	onClickGoogleImage(value : any) {
		var replaced = value.split("+").join("+%2B+");
		window.location.href = `https://www.google.com/search?tbm=isch&q=${replaced}`;
	}

	onClickVolumeIcon(text : string) {
		const s = this.formartBeforeSpeaking(text);
		if ("speechSynthesis" in window) {
			var msg = new SpeechSynthesisUtterance();
			msg.text = s;
			window.speechSynthesis.speak(msg);
		} else {
			console.log("Don't support speechSynthesis");
		}
	}

	onClickMicIcon(keyword : any) {
		const { webkitSpeechRecognition, SpeechRecognition } : IWindow = <IWindow>(
			(<unknown>window)
		);
		var speechRecognition = SpeechRecognition || webkitSpeechRecognition;
		var recognition = new speechRecognition();
		recognition.lang = "en-US";
		recognition.onresult = function (event : { results : string | any[] }) {
			var lastResult = event.results.length - 1;
			var content = event.results[lastResult][0].transcript;
			console.log(event);
			console.log("keyword:", keyword.keyword_en);
			if (
				keyword.keyword_en.toLocaleLowerCase() === content.toLocaleLowerCase()
			) {
				alert("Correct!");
			} else {
				alert(
					`Not Correct!: ${content} is not match with ${keyword.keyword_en}`
				);
			}
		};
		recognition.onspeechend = function () {
			recognition.stop();
		};

		recognition.onerror = function (event : { error : string }) {
			alert("Error occurred in recognition: " + event.error);
		};
		recognition.start();
	}

}